class OfferCountdown extends HTMLElement {
  connectedCallback() {
    const raw = this.dataset.deadline;
    if (!raw) return;
    this.deadline = new Date(raw);
    if (Number.isNaN(this.deadline.getTime())) return;

    this.labelDays = this.dataset.labelDays || 'd';
    this.labelHours = this.dataset.labelHours || 'h';
    this.labelMinutes = this.dataset.labelMinutes || 'm';
    this.labelSeconds = this.dataset.labelSeconds || 's';
    this.labelEnded = this.dataset.labelEnded || 'Oferta finalizada';

    this.render();
    this.interval = setInterval(() => this.render(), 1000);
  }

  disconnectedCallback() {
    if (this.interval) clearInterval(this.interval);
  }

  render() {
    const diff = this.deadline.getTime() - Date.now();
    if (diff <= 0) {
      this.innerHTML = `<span class="offer-countdown__ended">${this.labelEnded}</span>`;
      if (this.interval) clearInterval(this.interval);
      this.setAttribute('data-ended', '');
      return;
    }
    const d = Math.floor(diff / 86400000);
    const h = Math.floor((diff % 86400000) / 3600000);
    const m = Math.floor((diff % 3600000) / 60000);
    const s = Math.floor((diff % 60000) / 1000);
    const pad = (n) => String(n).padStart(2, '0');
    this.innerHTML = `
      <span class="offer-countdown__item"><strong>${d}</strong><span class="offer-countdown__label">${this.labelDays}</span></span>
      <span class="offer-countdown__sep" aria-hidden="true">:</span>
      <span class="offer-countdown__item"><strong>${pad(h)}</strong><span class="offer-countdown__label">${this.labelHours}</span></span>
      <span class="offer-countdown__sep" aria-hidden="true">:</span>
      <span class="offer-countdown__item"><strong>${pad(m)}</strong><span class="offer-countdown__label">${this.labelMinutes}</span></span>
      <span class="offer-countdown__sep" aria-hidden="true">:</span>
      <span class="offer-countdown__item"><strong>${pad(s)}</strong><span class="offer-countdown__label">${this.labelSeconds}</span></span>
    `;
  }
}

if (!customElements.get('offer-countdown')) {
  customElements.define('offer-countdown', OfferCountdown);
}
